import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portal Component
 * A component that renders its children into a portal at the document body level.
 * Useful for rendering modals, tooltips, or any content that needs to break out of its parent's DOM hierarchy.
 *
 * @component
 * @param {Object} props - Component props
 * @param {ReactNode} props.children - Child elements to render in the portal
 * @returns {ReactPortal} Portal containing the children rendered at document.body
 *
 * @example
 * // Rendering a modal using Portal
 * <Portal>
 *   <div className="modal">
 *     <h1>Modal Content</h1>
 *     <p>This content will render at document.body level</p>
 *   </div>
 * </Portal>
 */
export function Portal({ children }: PropsWithChildren) {
  return createPortal(children, document.body);
}
